import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import React from "react";

import { SectionLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUIFilterablePaginatedSectionCategoryNavigationNonRSC } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/CategoryNavigation/SDUIFilterablePaginatedSectionCategoryNavigationNonRSC";
import { FilterablePaginatedSectionFiltersNonRSC } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/FilterablePaginatedSectionFiltersNonRSC";
import { sideBarWrapper } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";

export const FilterablePaginatedSectionSideBarRendererNonRSC: React.FC<{
  filterablePaginatedSection: IFilterablePaginatedSection;
  sectionLoggingData: SectionLoggingEventParams;
}> = ({ filterablePaginatedSection, sectionLoggingData }) => {
  return (
    <div className={sideBarWrapper}>
      <SDUIFilterablePaginatedSectionCategoryNavigationNonRSC
        filterablePaginatedSection={filterablePaginatedSection}
      />
      <FilterablePaginatedSectionFiltersNonRSC
        filterablePaginatedSection={filterablePaginatedSection}
        sectionLoggingData={sectionLoggingData}
      />
    </div>
  );
};
